import * as eventTypes from "./eventTypes";
import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const folderNextStatesReducer = (state = initialState.currentFolder.nextStates, action) => {
  switch (action.type) {
    case actionTypes.COMPUTE_FOLDER_NEXT_STATES_STARTED: {
      return Object.assign([], state, { loading: true });
    }

    case eventTypes.FOLDER_NEXT_STATES_LIST_COMPUTED: {
      return Object.assign(action.event.eventBody.nextStates, { isLoaded: true, loading: false });
    }

    case eventTypes.FOLDER_NEXT_STATES_LIST_INVALIDATED: {
      return initialState.currentFolder.nextStates;
    }

    default:
      return state;
  }
};

export default folderNextStatesReducer;
